import React from "react";
import { Switch } from "react-router-dom";
import PrivateRoute from "components/common/PrivateRoute";

import ExportOrder from "components/menu/export/orders/list";

const ExportOrdersRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={ExportOrder}
            />
        </Switch>
    </div>
);

export default ExportOrdersRouter;
